module.exports = __webpack_public_path__ + "img/slide_01_th.0cfb43ca.jpg";